import { faker } from '@faker-js/faker';
import { IClaimMessengerMetadataConversation } from 'app/claims/components/messenger/interfaces/claim-messenger-metadata-conversation.interface';
import { makeSyncStatus } from 'app/mocks/factories/claims/makes/make-sync-status';

export function makeClaimConversationMetadataConversation(overrides: Partial<IClaimMessengerMetadataConversation> = {}): IClaimMessengerMetadataConversation {
    const totalCount = faker.number.int({ min: 1, max: 200 });
    const unreadAdjusterCount = faker.number.int({ min: 0, max: totalCount });
    const syncStatus = makeSyncStatus({ syncFailed: overrides.syncFailed });

    return {
        topic: overrides.topic!,
        totalCount,
        unreadAdjusterCount,
        ...syncStatus,
        ...overrides,
    };
}
